var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Select from 'react-select';
import sortBy from 'lodash.sortby';
import moment from 'moment-timezone';
import { List } from 'react-virtualized';
import { formatTimezone } from './formatTimezone';
export * from './formatTimezone';
export const getTimezoneProps = (tzString) => {
    const tz = moment.tz(tzString);
    const tzStringOffset = tz.format('Z').replace(':00', '').replace(':30', '.5');
    let x = tzStringOffset === 0 ? 0 : parseInt(tzStringOffset).toFixed(2);
    return {
        label: formatTimezone(tzString),
        value: `${tzString}`,
        time: `${x}`,
        offset: tz._offset,
    };
};
export const makeVirtualMenuListComponent = (ListProps) => {
    return (props) => {
        return (React.createElement(List, Object.assign({ rowCount: props.children.length, style: {
                width: '100%',
            }, rowHeight: 34.18, height: 300, width: 600, rowRenderer: ({ key, index, style }) => {
                return (React.createElement("div", { style: style, key: key }, props.children[index]));
            } }, ListProps)));
    };
};
export class SelectTimezone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        const timeZones = moment.tz.names().map((tz) => {
            return getTimezoneProps(tz);
        });
        this.timeZones = sortBy(timeZones, [
            function (el) {
                return -el.time;
            },
        ]);
    }
    componentDidMount() {
        const { onChange, value } = this.props;
        if (this.props.guess && !value) {
            const guessed = moment.tz.guess();
            onChange && onChange(guessed);
            this.setState({
                selectedValue: guessed,
            });
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value === undefined) {
            return null;
        }
        if (nextProps.value != prevState.selectedValue) {
            return {
                selectedValue: nextProps.value,
            };
        }
        return null;
    }
    render() {
        const _a = this.props, { onChange, value: selectedTimezoneValue, isClearable = false, className } = _a, restProps = __rest(_a, ["onChange", "value", "isClearable", "className"]);
        const selectClassName = className ? className : 'react-select-timezone';
        const selected = this.timeZones.find(({ value }) => {
            return value === this.state.selectedValue;
        });
        return (React.createElement(Select, Object.assign({ className: selectClassName, isClearable: isClearable, options: this.timeZones, isMulti: false, onChange: (option) => {
                if (option) {
                    this.setState({ selectedValue: option.value });
                    onChange && onChange(option.value);
                }
                else {
                    this.setState({ selectedValue: null });
                    onChange && onChange(null);
                }
            }, value: selected }, restProps)));
    }
}
